import { makeStyles } from '@material-ui/core'
import { Theme } from '@styles/theme/theme'

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '32px'
    }
  },
  title: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '30px',
    maxWidth: '480px',
  },

  error: {
    fontSize: '12px',
    color: theme.palette.error.main,
    marginBottom: 10,
  },

  textFieldContainer: {
    gap: 20,
    maxWidth: '524px',
    margin: '0 auto'
  },

  textField: {
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '28px',
    textAlign: 'center',
    width: '524px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },

  textFieldError: {
    color: theme.palette.error.main,

    '& textarea': {
      color: theme.palette.error.main,
    },

    '& .MuiInput-underline:before': {
      borderBottom: '2px solid rgba(255, 0, 0, 0.42)'
    },

    '& .MuiInput-underline:after': {
      borderBottom: '2px solid ' + theme.palette.error.main,
    }
  },
}))

export default useStyles
